<template>
    
  <div v-if="companyClient.id" class="Typeahead user-caller-typeahead">
    
     <div class="input-group  input-group-lg">
      <span class="input-group-addon">
        <span class="glyphicon glyphicon-search" aria-hidden="true"></span>
      </span>
      <input type="text"
             id="caller-typeahead"
             class="form-control"
             placeholder="Anrufer suchen..."
             autocomplete="off"
             v-model="query"
             @keydown.down="down"
             @keydown.up="up"
             @keydown.enter="hit($event)"
             @keydown.esc="reset"
             @input="update"/>
  <!-- @blur="reset" -->
            
       <span class="input-group-btn">
        <button type="button"
          v-show="companyClient.callerShowPeriod >= 0" 
          class="btn "
          :class="{'btn-primary': callerShowPeriodFilterActive}" 
          @click="onClickCallerShowPeriodFilter" 
        >
          <span class="glyphicon glyphicon-filter" aria-hidden="true"></span>
          <span title="VIP und Mitarbeiter werden immer angezeigt">{{textCallerShowPeriod}}</span>
        </button>
      </span>
    </div>
    
    <div v-show="nothingFound" class="alert alert-warning" role="alert">Anrufer nicht gefunden</div>

    <ul v-show="hasItems">
      <li v-for="(item, index) in items" :class="activeClass(index)" @mousedown="hit" @mousemove="setActive(index)">
        <span class="name" v-html="highlight(userType[item.idSex].sexText)"></span> 
        <span class="name" v-html="highlight(item.firstName)"></span>
        <span class="name" v-html="highlight(item.lastName)"></span>
        <span v-show="item.customerNumber" class="name">, KdNr: </span>
        <span class="name" v-html="highlight(item.customerNumber)"></span>
        <span v-show="item.callerCity" class="screen-name">, (</span>
        <span class="screen-name" v-html="highlight(item.callerCity)"></span>
        <span  v-show="item.callerCity" class="screen-name">)</span>
        <span v-if="item.companyName" >
          <span class="screen-name">Fa. </span>
          <span class="screen-name" v-html="highlight(item.companyName)"></span>
          <span class="screen-name"> (</span>
          <span class="screen-name" v-html="highlight(item.companyCity)"></span>
          <span class="screen-name">)</span>
        </span>
        <span class="screen-name"> {{item.callDateTimeBegin}}</span>
        <div>
          <span class="screen-phone" v-html="highlight(item.phoneNumbers)"></span>
        </div>
        <div>
          <span class="screen-info" v-text="item.info"></span>
        </div>
      </li>
    </ul>
  </div>
</template>



<script>

import VueTypeahead from './common/typeahead.common'
import bus from './common/bus'



export default {
  extends: VueTypeahead,

  data () {
    return {
      limit: 10,
      minChars: 1,
      takeFirstItemOnHit: false,
      userType: {
         '': {class: 'fa-question', text: 'Unbekannt', sexText: ''},
         0: {class: 'fa-question', text: 'Unbekannt', sexText: ''},
         1: {class: 'fa-user', text: 'Herr', sexText: 'Herr'},
         2: {class: 'fa-user', text: 'Frau', sexText: 'Frau'},
         3: {class: 'fa-users', text: 'Abteilung', sexText: ''},
         4: {class: 'fa-commenting', text: 'Thema', sexText: ''}
      },
      callerShowPeriodFilterActive: true,
      companyClient:{
        id: 0,
        callerShowPeriod: '',
      }, 
      
    }
  },
  created: function () {
    //bus.registerOnLogin(this.reset);
    bus.registerOnCompanyClient(this.onCompanyClient);
    bus.registerOnResetCompanyClient(this.onResetCompanyClient);
    bus.registerOnMessageSearch(this.onMessageSearch);

  },

  
  
  computed: {
    src: function () {
      return bus.config.path + '/search/callers/' + this.companyClient.id
    },
    
    textCallerShowPeriod: function () {
              
      if( this.companyClient.callerShowPeriod == "0"){
        return 'Heute';
      }else if(this.companyClient.callerShowPeriod == "1"){
        return '1 Tag';
      }else{
        return this.companyClient.callerShowPeriod + ' Tage';
      }
    },
  },
  
  methods: {


    onBeginSearch(){
      //bus.emitIdUserCaller(0);
      $('.user-caller-typeahead').find('input').css("background-color","#fff");

    },
    
    onHit (item ) {
      bus.emitIdUserCaller(item.idCaller);
      this.reset();
    },
    
    onHitNew (query) {
      bus.emitNewUserCaller(query);
      this.reset();
    },
    
    highlight: function(value){
        var query = this.query.substring(0,1) == '%' ? this.query.substring(1) : this.query;
        var querys =  query.trim().split(/\s+/g);
        querys.forEach(function(q, index, array) {
          value = value.replace( RegExp("^("+q+")","gi"), '<b>$1</b>' );
        });
        // console.log('UserCallerTypeahead:highlight:' + value);
        return value;
    },

    // enable/disable Filter
    onClickCallerShowPeriodFilter: function(){
      
      if(this.callerShowPeriodFilterActive){
        this.callerShowPeriodFilterActive = false;
        this.options = {};
      }else{
        this.callerShowPeriodFilterActive = true;
        this.options = {period: this.companyClient.callerShowPeriod};
      }
      this.update();
    },
    
    onCompanyClient: function(companyClient){
      //console.log('UserCallerTypahead:onCompanyClient: ');
      //this.reset();

      this.companyClient.id = companyClient.id;
      this.companyClient.callerShowPeriod = companyClient.callerShowPeriod;
      this.callerShowPeriodFilterActive = true;
      
      this.options = {period: this.companyClient.callerShowPeriod};
 
      //console.log('UserCallerTypeahead:onIdCompanyClient: ' + companyClient.id);
      if(this.companyClient.id != 0){
        this.$nextTick(function () {
          //document.getElementById("caller-typeahead").focus();
        })
      }
    },

    onResetCompanyClient: function(){
      //console.log('UserCallerTypahead:onResetCompanyClient: ');
      this.reset();
      this.companyClient.id = 0;
      this.companyClient.callerShowPeriod = '';
    },
    
    onMessageSearch: function(query, event, call){
      // nur wenn kein Anrufer ausgewählt ist 
      //console.log('UserCallerTypahead:onMessageSearch: ' + query);
      if(call.idUserCaller == 0){
        this.query = query;
        this.update();
      }
    }
  }
  
}
</script>



<style scoped>
.Typeahead {
  position: relative;
}

.Typeahead__input {
  width: 100%;
  font-size: 14px;
  color: #2c3e50;
  line-height: 1.42857143;
  box-shadow: inset 0 1px 4px rgba(0,0,0,.4);
  -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  font-weight: 300;
  padding: 12px 26px;
  border: none;
  border-radius: 22px;
  letter-spacing: 1px;
  box-sizing: border-box;
}

.Typeahead__input:focus {
  border-color: #4fc08d;
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px #4fc08d;
}

.fa-times {
  cursor: pointer;
}

i {
  float: right;
  position: relative;
  top: 30px;
  right: 29px;
  opacity: 0.4;
}

ul {
  position: absolute;
  padding: 0;
  margin-top: 8px;
  min-width: 100%;
  background-color: rgb(255, 254, 234);
  list-style: none;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0,0,0, 0.25);
  z-index: 1000;
  max-height: 37vh;
  overflow: auto;
}

li {
  padding: 10px 16px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

li:first-child {
  border-radius: 4px 4px 0 0;
}

li:last-child {
  border-radius: 0 0 4px 4px;
  border-bottom: 0;
}

li span{
  color: #2c3e50;
}

.active {
  background-color: #b0e6cd;
  /* background-color: #eee; */
}

.active span {
 /*color: white;*/
}

.name {
  font-weight: 400;
  font-size: 18px;
}

.screen-name {
  font-style: italic;
  color: #aaa;
}

.screen-phone {
  font-style: italic;
  color: blue;
}

.screen-info {
  font-style: italic;
  color: red;
}
  
  .alert{
    margin-top: 10px;
  }  
  
 
  
</style>



// WEBPACK FOOTER //
// UserCallerTypeahead.vue?7fb670f7